export default __webpack_public_path__ + "static/media/board-btn-smd.0d600c74.svg";